import React, { ButtonHTMLAttributes } from 'react';

import { NavigationTracker, NavigationTrackerProps } from './NavigationTracker';

export const NavigationTrackerButton = ({
    disableTracking,
    source,
    href,
    onClick,
    ...props
}: NavigationTrackerProps<ButtonHTMLAttributes<HTMLButtonElement>> & ButtonHTMLAttributes<HTMLButtonElement>) => (
    <NavigationTracker<ButtonHTMLAttributes<HTMLButtonElement>> disableTracking={disableTracking} source={source} href={href} onClick={onClick}>
        {(_, onClick) => <button onClick={onClick} {...props}></button>}
    </NavigationTracker>
);
